import { render, staticRenderFns } from "./mediaSort.vue?vue&type=template&id=9b8a217e&scoped=true&"
import script from "./mediaSort.vue?vue&type=script&lang=js&"
export * from "./mediaSort.vue?vue&type=script&lang=js&"
import style0 from "./mediaSort.vue?vue&type=style&index=0&id=9b8a217e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8a217e",
  null
  
)

component.options.__file = "mediaSort.vue"
export default component.exports